module.exports = __webpack_public_path__ + "public/files/img/logo.e86cfc1a.png";